export * from "./config"; // 埋点方法
export * from "./common-properties"; // 通用属性
export * from "./home"; // 首页
